import React from 'react';
import { BonusesSection, FAQSection, Guarantee, Pain, ProductOverview, Results, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2riklx1c3g39f">
      <MetaPixel data-id="element-1" data-mp="31b8lu4ydencd" />
      <TopBar data-id="element-2" data-mp="31bs09botatln" />
      <main data-id="element-3" data-mp="31c9vq63nh3si">
        <Hero data-id="element-4" data-mp="31c1ksjr388jy" />
        <Testimonials data-id="element-5" data-mp="31cjou2jzrr2f" />
        <Pain data-id="element-6" data-mp="2wjgqlh49rtfw" />
        <ProductOverview data-id="element-7" data-mp="2wjqff1dkvuk0" />
        <BonusesSection data-id="element-8" data-mp="2wifgpfyzpczr" />
        <Pricing data-id="element-9" data-mp="2wi5nzkmk8rqd" />
        <Results data-id="element-10" data-mp="28u5x8kp911bs" />
        <Guarantee data-id="element-11" data-mp="28tmfp53igeya" />
        <FAQSection data-id="element-12" data-mp="28t4kmbsl46ry" />
      </main>
      <Footer data-id="element-13" data-mp="28sbe9bxjfjac" />
      <FloatingElements data-id="element-14" data-mp="23vci6nubd29i" />
      <noscript data-id="element-15" data-mp="23w4g45bdvc2y">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-16" data-mp="23ujk0b9f7l2z" />
      </noscript>
    </div>;
}